import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DynamicFormModalComponent } from '@ispm/dynamic-form/components/dynamic-form-modal/dynamic-form-modal.component';
import { DynamicFormModalPayload } from '@ispm/dynamic-form/classes/dynamic-form-modal-payload.class';

@Component({
  selector: 'ispm-selectable-modal',
  templateUrl: './selectable-modal.component.html',
  styleUrls: ['./selectable-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectableModalComponent extends DynamicFormModalComponent<SelectableModalPayload> implements OnInit {

  constructor(_changeDetector: ChangeDetectorRef) {
    super(_changeDetector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  statusUpdate($event: boolean) {
    this.payload.selectedStatus = $event;
    if (this.payload.onSelectChange) {
      this.payload.onSelectChange(this.payload.selectedStatus);
    }
  }
}

export class SelectableModalPayload extends DynamicFormModalPayload {
  onSelectChange: (status: boolean ) => void;
  selectedStatus: boolean;
  showSelectable: boolean;

  public static builder() {
    return new this();
  }

  setOnSelectChangeCallback(callback: (status: boolean) => void) {
    this.onSelectChange = callback;
    return this;
  }

  setSelectedStatus(status: boolean) {
    this.selectedStatus = status;
    return this;
  }

  setShowSelectable(show: boolean) {
    this.showSelectable = show;
    return this;
  }
}
